import { render } from "./BaseLabel.vue?vue&type=template&id=75527f4d&scoped=true"
import script from "./BaseLabel.js?vue&type=script&lang=js"
export * from "./BaseLabel.js?vue&type=script&lang=js"

import "./BaseLabel.scss?vue&type=style&index=0&id=75527f4d&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./BaseLabel.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Firshadck%2Fprojects%2Fsunrise-spa%2Fsrc%2Fpresentation%2Ffashion%2Fcomponents%2FBaseInput%2FBaseLabel%2FBaseLabel.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/irshadck/projects/sunrise-spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75527f4d"]])

export default __exports__